
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...config]",
      function () {
        return require("private-next-pages/[...config].js");
      }
    ]);
  